export default __webpack_public_path__ + "static/media/picto-m1.041a679b.svg";